import { useQuery } from "react-query";
import axios from "axios";
import {
  getCommonHeaderVE,
  getExhibitorHeader,
  getHeader,
} from "../../../../utility/utility";
import {
  API_ENDPOINT,
  EXHIBITOR_API,
  USER,
} from "../../../../constants/constants";
const fetchItems = async (page = 1, id) => {
  let url = `${API_ENDPOINT}${USER}/get-brochures?page=${page}&id=${id}`;
  try {
    const res = await axios.get(url, getHeader());
    return res.data;
  } catch (error) {
    throw error.response.data;
  }
};

const useBrochures = (page, id) => {
  const queryInfo = useQuery(
    ["get-brochures", page, id],
    () => fetchItems(page, id),
    {
      staleTime: 5 * 60 * 1000,
      retry: 3,
    }
  );

  return {
    ...queryInfo,
    refetchBrochures: queryInfo.refetch, // Extract refetch function from queryInfo
  };
};

export default useBrochures;
